import React from 'react';

import {
  Column,
  ErrorTag,
  OutlineButton,
  PrimaryButton,
} from 'components/layout/Auth/AuthForm/styles';

import {
  CONTENT_WIDTH,
  MaskedEmail,
  NarrowActions,
  OnboardingIntro,
  OnboardingSubtitle,
  TitleMedium,
} from '../styles';

type ValidacaoProps = {
  email: string;
  loading: boolean;
  erro: string | null;
  onSubmit: () => void;
  onBack: () => void;
};

export const maskEmail = (email: string): string => {
  const [usuario, dominio] = email.split('@');

  if (!dominio) return email;
  if (usuario.length <= 3) return `${usuario}****@${dominio}`;

  return `${usuario.slice(0, 3)}****@${dominio}`;
};

const Validacao = ({
  email,
  loading,
  erro,
  onSubmit,
  onBack,
}: ValidacaoProps): JSX.Element => {
  return (
    <Column gap={24} width={CONTENT_WIDTH}>
      <OnboardingIntro>
        <TitleMedium>
          Será enviado um código de validação para o e-mail abaixo
        </TitleMedium>
        <OnboardingSubtitle>
          Clique em continuar para prosseguir com o envio
        </OnboardingSubtitle>
      </OnboardingIntro>

      <MaskedEmail>{maskEmail(email)}</MaskedEmail>

      {!!erro && <ErrorTag role="alert">{erro}</ErrorTag>}

      <NarrowActions>
        <OutlineButton
          type="button"
          variant="secondary"
          shape="pill"
          fullWidth
          onClick={onBack}
        >
          Voltar
        </OutlineButton>
        <PrimaryButton
          type="button"
          shape="pill"
          fullWidth
          disabled={loading}
          onClick={onSubmit}
        >
          {loading ? 'Enviando...' : 'Continuar'}
        </PrimaryButton>
      </NarrowActions>
    </Column>
  );
};

export default Validacao;
